import React, { useEffect } from 'react'
import { ColumnsType } from 'antd/es/table'
import { Button, Popconfirm, Table, Typography } from 'antd'
import { ICustomerMergeItem } from '../../../AccountTypes'
import { useMergerModel } from './summaryModel'



export function DataTable() {
    const { dataSource,initPgCfg,setSearchParam, selectedRowKeys, pgCfg, loadData, setSelectedRowKeys, editCustomerMerger, deleteCustomerMerger } = useMergerModel((model) => [model.dataSource, model.selectedRowKeys])
    useEffect(() => {
        setSearchParam({});
        loadData(initPgCfg, {})
    }, [])

    //点击行选高亮
    const onRow = (record: ICustomerMergeItem) => {
        let findObj = selectedRowKeys.find((item) => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter((item) => item.id !== record.id)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            setSelectedRowKeys((origin) => [...origin, record])
        }
    }


    const columns: ColumnsType<ICustomerMergeItem> = [
        {
            align: 'center',
            width: 300,
            ellipsis: true,
            title: '客户名称',
            dataIndex: 'customerName',
        },
        {
            align: 'center',
            width: 200,
            ellipsis: true,
            title: '授信额度',
            dataIndex: 'totalCreditAmount',
            render: (t) => t ?? 0
        },
        {
            align: 'center',
            width: 100,
            ellipsis: true,
            title: '已用额度',
            dataIndex: 'totalUsedAmount',
            render: (t) => t ?? 0
        },
        {
            align: 'center',
            width: 100,
            ellipsis: true,
            title: '可用额度',
            dataIndex: 'totalAvailableAmount',
            render: (t) => t ?? 0
        },
        {
            align: 'center',
            width: 100,
            ellipsis: true,
            title: '剩余金额',
            dataIndex: 'totalRemainingAmount',
            render: (t) => t ?? 0
        },
        {
            align: 'center',
            width: 100,
            ellipsis: true,
            title: '欠款',
            dataIndex: 'totalDebtAmount',
            render: (t) => t ?? 0
        },
        {
            align: 'center',
            width: 100,
            ellipsis: true,
            title: '合并客户数',
            dataIndex: 'mergeNum',
        },
        {
            title: '操作',
            width: 180,
            align: 'center',
            fixed: 'right',
            render: (text, record) => (
                <>
                    <Typography.Link style={{ marginRight: 8 }} onClick={() => editCustomerMerger(record)}>
                        关联关系
                    </Typography.Link>
                    <Popconfirm title="确认要解除关联吗?" onConfirm={() => deleteCustomerMerger(record.id)}>
                        <a>解除关联</a>
                    </Popconfirm>
                </>
            ),
        },
    ]


    return (
        <Table
            rowKey = {(r) => r.id}
            rowSelection={{
                //全部选中时 (存row[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    selected
                        ? setSelectedRowKeys((origin) => [...origin, ...changeRows])
                        : setSelectedRowKeys((origin) => {
                              let changeRowId = changeRows.map((item) => item.id)
                              return origin.filter((item) => changeRowId.indexOf(item.id) < 0)
                          })
                },
                onSelect: (record, selected, selectedRows) => onRow(record),
                selectedRowKeys: selectedRowKeys.map((item) => item.id),
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ['bottomCenter'],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
            }}
            onRow={(record) => ({
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault()
                    setSelectedRowKeys([record])
                },
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
        />
    )
}
